var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#6AB7C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3312 9.24486C14.4685 9.24483 14.6055 9.25851 14.7401 9.28569C15.1655 9.36759 15.5568 9.5758 15.8633 9.88344C16.1698 10.1911 16.3776 10.584 16.4597 11.0115L16.5301 11.379L16.8957 11.4443C17.2649 11.5082 17.5967 11.7095 17.8248 12.0083C18.0529 12.3071 18.1606 12.6813 18.1265 13.0563C18.0923 13.4314 17.9188 13.7797 17.6405 14.0319C17.3622 14.284 16.9995 14.4215 16.6249 14.4169H12.0294C11.6547 14.4215 11.2921 14.284 11.0138 14.0319C10.7355 13.7797 10.562 13.4314 10.5278 13.0563C10.4936 12.6813 10.6013 12.3071 10.8294 12.0083C11.0576 11.7095 11.3893 11.5082 11.7586 11.4443L12.1214 11.379L12.1918 11.0115C12.2873 10.5124 12.5534 10.0625 12.9441 9.73983C13.3348 9.41718 13.8255 9.24208 14.3312 9.24486ZM14.3312 8.70044C13.7009 8.69991 13.0902 8.92038 12.6043 9.32386C12.1184 9.72734 11.7877 10.2885 11.6692 10.9108C11.1705 11.0016 10.7235 11.2765 10.4161 11.6816C10.1088 12.0867 9.96316 12.5926 10.0079 13.1001C10.0527 13.6076 10.2847 14.0799 10.6582 14.4243C11.0317 14.7686 11.5198 14.9602 12.0267 14.9613H16.6303C17.1371 14.9602 17.6253 14.7686 17.9988 14.4243C18.3723 14.0799 18.6042 13.6076 18.649 13.1001C18.6938 12.5926 18.5482 12.0867 18.2408 11.6816C17.9334 11.2765 17.4865 11.0016 16.9878 10.9108C16.8858 10.3756 16.6263 9.88345 16.243 9.49811C15.8596 9.11278 15.37 8.85197 14.8376 8.74944C14.6706 8.71759 14.5011 8.70119 14.3312 8.70044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9958 15.9011C11.1712 15.95 11.2735 16.1309 11.2244 16.3053L10.6474 18.3546C10.5983 18.529 10.4163 18.6308 10.2409 18.582C10.0656 18.5332 9.96319 18.3522 10.0123 18.1778L10.5893 16.1285C10.6385 15.9541 10.8204 15.8523 10.9958 15.9011Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1702 19.2245C12.3347 19.272 12.4306 19.4477 12.3846 19.6171L11.8436 21.6079C11.7976 21.7773 11.627 21.8762 11.4626 21.8288C11.2981 21.7813 11.2022 21.6056 11.2482 21.4362L11.7892 19.4454C11.8352 19.276 12.0058 19.1771 12.1702 19.2245Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5665 15.9011C14.7309 15.95 14.8269 16.1309 14.7808 16.3053L14.2398 18.3546C14.1938 18.529 14.0232 18.6308 13.8588 18.582C13.6944 18.5332 13.5984 18.3522 13.6445 18.1778L14.1854 16.1285C14.2315 15.9541 14.4021 15.8523 14.5665 15.9011Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7881 19.2245C15.9635 19.272 16.0659 19.4477 16.0168 19.6171L15.4397 21.6079C15.3906 21.7773 15.2086 21.8762 15.0333 21.8288C14.8579 21.7813 14.7556 21.6056 14.8047 21.4362L15.3817 19.4454C15.4308 19.276 15.6128 19.1771 15.7881 19.2245Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1992 15.9011C18.3636 15.95 18.4595 16.1309 18.4135 16.3053L17.8725 18.3546C17.8265 18.529 17.6559 18.6308 17.4915 18.582C17.3271 18.5332 17.2311 18.3522 17.2772 18.1778L17.8181 16.1285C17.8642 15.9541 18.0348 15.8523 18.1992 15.9011Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6779 7C25.8558 7 26 7.14384 26 7.32127V27.6816C26 28.1696 25.6034 28.5651 25.1141 28.5651H16.7377C16.5598 28.5651 16.4155 28.4213 16.4155 28.2438C16.4155 28.0664 16.5598 27.9226 16.7377 27.9226H25.1141C25.2475 27.9226 25.3557 27.8147 25.3557 27.6816V7.32127C25.3557 7.14384 25.4999 7 25.6779 7Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1352 25.8986C22.1352 25.7065 22.2794 25.5508 22.4573 25.5508H25.6778C25.8557 25.5508 25.9999 25.7065 25.9999 25.8986C25.9999 26.0907 25.8557 26.2464 25.6778 26.2464H22.4573C22.2794 26.2464 22.1352 26.0907 22.1352 25.8986Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1401 23.4637C23.1401 23.293 23.2824 23.1545 23.4579 23.1545H25.6823C25.8578 23.1545 26 23.293 26 23.4637C26 23.6345 25.8578 23.7729 25.6823 23.7729H23.4579C23.2824 23.7729 23.1401 23.6345 23.1401 23.4637Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1352 21.0675C22.1352 20.8967 22.2794 20.7583 22.4573 20.7583H25.6778C25.8557 20.7583 25.9999 20.8967 25.9999 21.0675C25.9999 21.2382 25.8557 21.3767 25.6778 21.3767H22.4573C22.2794 21.3767 22.1352 21.2382 22.1352 21.0675Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1352 16.2367C22.1352 16.0446 22.2794 15.8889 22.4573 15.8889H25.6778C25.8557 15.8889 25.9999 16.0446 25.9999 16.2367C25.9999 16.4288 25.8557 16.5846 25.6778 16.5846H22.4573C22.2794 16.5846 22.1352 16.4288 22.1352 16.2367Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1401 13.8405C23.1401 13.6484 23.2824 13.4927 23.4579 13.4927H25.6823C25.8578 13.4927 26 13.6484 26 13.8405C26 14.0326 25.8578 14.1883 25.6823 14.1883H23.4579C23.2824 14.1883 23.1401 14.0326 23.1401 13.8405Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1352 11.4059C22.1352 11.2351 22.2794 11.0967 22.4573 11.0967H25.6778C25.8557 11.0967 25.9999 11.2351 25.9999 11.4059C25.9999 11.5766 25.8557 11.715 25.6778 11.715H22.4573C22.2794 11.715 22.1352 11.5766 22.1352 11.4059Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1401 9.00962C23.1401 8.83886 23.2824 8.70044 23.4579 8.70044H25.6823C25.8578 8.70044 26 8.83886 26 9.00962C26 9.18037 25.8578 9.31879 25.6823 9.31879H23.4579C23.2824 9.31879 23.1401 9.18037 23.1401 9.00962Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1401 18.6715C23.1401 18.5007 23.2824 18.3623 23.4579 18.3623H25.6823C25.8578 18.3623 26 18.5007 26 18.6715C26 18.8422 25.8578 18.9807 25.6823 18.9807H23.4579C23.2824 18.9807 23.1401 18.8422 23.1401 18.6715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainGauge);
export default __webpack_public_path__ + "static/media/rain-gauge.1059f6c9.svg";
export { ForwardRef as ReactComponent };